import { render, staticRenderFns } from "./baseMessage.vue?vue&type=template&id=2cd93c4f&scoped=true"
import script from "./baseMessage.vue?vue&type=script&lang=js"
export * from "./baseMessage.vue?vue&type=script&lang=js"
import style0 from "./baseMessage.vue?vue&type=style&index=0&id=2cd93c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd93c4f",
  null
  
)

export default component.exports